export default {
  phoneBook: "phoneBook",
  keyPerson: "keyPerson",
};
